/* src/app/sections/alerts-section/alerts-section.component.css */
/*# sourceMappingURL=alerts-section.component.css.map */
